import React, { Suspense, useEffect } from "react";
import {Outlet, useLocation} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {StoryReadingModal, StoryDetailModal, StudentDetail,DeleteModal} from '../components/Modal'
import { QuizDetail } from "../components/Modal/QuizDetail";
import { initGA, logPageView } from "../utils/analytics";

const AnalyticsListener = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname);
  }, [location]);

  return null;
};

const App = () => {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <AnalyticsListener />
            <Outlet />
            <StoryReadingModal />
            <StoryDetailModal />
            <StudentDetail />
            <DeleteModal />
            <QuizDetail />
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
